import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComment,
  faTimes,
  faPlus,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { Input } from "antd";
import { useUserStore } from "../../stores/userStore";

const { TextArea } = Input;

export const Chatting = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentView, setCurrentView] = useState("list");
  const [selectedChat, setSelectedChat] = useState(null);
  const [hoveredRoom, setHoveredRoom] = useState(null);
  const [value, setValue] = useState("");

  const { userInfo } = useUserStore();
  const location = useLocation();

  const brandChatRooms = [
    {
      id: 1,
      name: "ㅇㅇㅇ",
      message: "~~~!",
      timestamp: "오후 2:30",
    },
    {
      id: 2,
      name: "ㅁㅁㅁ",
      message: "ㅇㅇㅇㅇㅇ!",
      timestamp: "오전 10:15",
    },
  ];

  const influencerChatRooms = [
    {
      id: 1,
      name: "나이키",
      message: "~~~~~",
      timestamp: "오후 3:20",
    },
    {
      id: 2,
      name: "아디다스",
      message: "~~~~~~~",
      timestamp: "오전 11:45",
    },
  ];

  const isBrand = userInfo?.user_info?.user_type === "brand";
  const chatRooms = isBrand ? brandChatRooms : influencerChatRooms;

  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setCurrentView("list");
    }
  };

  const openChatRoom = (chatRoom) => {
    setSelectedChat(chatRoom);
    setCurrentView("chat");
  };

  const goBackToList = () => {
    setCurrentView("list");
    setSelectedChat(null);
  };

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* 채팅 버튼 */}
      <div
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          zIndex: 1001,
        }}
      >
        <button
          onClick={toggleChat}
          style={{
            width: "60px",
            height: "60px",
            borderRadius: "24px",
            background: "black",
            border: "none",
            color: "white",
            fontSize: "24px",
            cursor: "pointer",
            boxShadow:
              "rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.1) 0px 4px 6px, rgba(0, 0, 0, 0.15) 0px 8px 30px",
            transition: "all 0.3s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon icon={isOpen ? faTimes : faComment} />
        </button>
      </div>

      {isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: "100px",
            right: "30px",
            width: "min(390px, calc(100vw - 60px))",
            height: "clamp(180px, calc(100vh - 200px), 550px)",
            backgroundColor: "white",
            borderRadius: "24px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            zIndex: 1001,
            fontSize: "14px",
          }}
        >
          {currentView === "list" ? (
            // 채팅방 리스트 없을 때
            <div style={{ padding: "10px" }}>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  padding: "6px 10px",
                }}
              >
                대화
              </div>
              <div
                style={{
                  flex: 1,
                  padding: "8px 6px",
                  overflowY: "auto",
                }}
              >
                {chatRooms.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      color: "#666",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faComment}
                      style={{
                        fontSize: "48px",
                        color: "#ccc",
                        marginBottom: "16px",
                      }}
                    />
                    <p style={{ margin: "0 0 20px 0", fontSize: "16px" }}>
                      대화를 시작해보세요
                    </p>
                    {!isBrand && (
                      <button
                        style={{
                          background: "#333",
                          color: "white",
                          border: "none",
                          borderRadius: "20px",
                          padding: "12px 20px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <FontAwesomeIcon icon={faPlus} />새 문의하기
                      </button>
                    )}
                  </div>
                ) : (
                  // 채팅방 리스트
                  <>
                    {chatRooms.map((room) => (
                      <div
                        key={room.id}
                        onClick={() => openChatRoom(room)}
                        onMouseEnter={() => setHoveredRoom(room.id)}
                        onMouseLeave={() => setHoveredRoom(null)}
                        style={{
                          background:
                            hoveredRoom === room.id ? "#e7e7e7" : "#fff",
                          borderRadius: "10px",
                          padding: "12px",
                          cursor: "pointer",
                          transition: "all 0.15s",
                          display: "flex",
                          gap: "12px",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            background: "#333",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <FontAwesomeIcon icon={faComment} />
                        </div>

                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "4px",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "15px",
                                fontWeight: "700",
                                color: "#222",
                              }}
                            >
                              {room.name}
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#8d8d8d",
                                marginLeft: "8px",
                              }}
                            >
                              {room.timestamp}
                            </div>
                          </div>
                          <div
                            style={{
                              fontSize: "14px",
                              color: "#555",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              wordBreak: "break-word",
                              overflowWrap: "anywhere",
                            }}
                          >
                            {room.message}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          ) : (
            <>
              {/* 채팅방 */}
              <div
                style={{
                  padding: "12px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexShrink: 0,
                }}
              >
                <button
                  onClick={goBackToList}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                    padding: "4px",
                  }}
                >
                  {`<`}
                </button>

                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "14px", fontWeight: "600" }}>
                    {selectedChat?.name}
                  </div>
                  <div style={{ fontSize: "12px", color: "#666" }}>
                    {isBrand ? "크리에이터" : "브랜드"}
                  </div>
                </div>
                <button
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "16px",
                    cursor: "pointer",
                    padding: "4px",
                  }}
                >
                  ⋮
                </button>
              </div>

              <div
                style={{
                  flex: 1,
                  padding: "16px",
                  overflowY: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "4px",
                    }}
                  >
                    <div style={{ fontSize: "14px", fontWeight: "600" }}>
                      {selectedChat?.name}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          background: "#F2F2F2",
                          padding: "8px 12px",
                          borderRadius: "12px",
                          maxWidth: "200px",
                          fontSize: "14px",
                        }}
                      >
                        안녕하세요! 진행하신 미션에 대해 피드백을 드립니다.
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: "#666",
                          marginTop: "4px",
                        }}
                      >
                        오후 2:30
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: "4px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#666",
                            whiteSpace: "nowrap",
                          }}
                        >
                          오후 2:32
                        </div>
                        <div
                          style={{
                            background: "#007bff",
                            color: "#fff",
                            padding: "8px 12px",
                            borderRadius: "12px",
                            maxWidth: "200px",
                            fontSize: "14px",
                          }}
                        >
                          네
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "4px",
                    }}
                  >
                    <div style={{ fontSize: "14px", fontWeight: "600" }}>
                      {selectedChat.name}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          background: "#F2F2F2",
                          padding: "8px 12px",
                          borderRadius: "12px",
                          maxWidth: "200px",
                          fontSize: "14px",
                        }}
                      >
                        {selectedChat.message}
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: "#666",
                          marginTop: "4px",
                        }}
                      >
                        {selectedChat.timestamp}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* 메시지 입력창 */}
              <div
                style={{
                  padding: "12px 16px",
                  borderTop: "1px solid #eee",
                  background: "#fff",
                  display: "flex",
                  gap: "8px",
                  alignItems: "flex-end",
                  flexShrink: 0,
                }}
              >
                {/* <button
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "16px",
                    cursor: "pointer",
                    padding: "4px",
                    color: "black",
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button> */}

                <TextArea
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder="메시지를 입력해주세요."
                  autoSize={{ minRows: 1, maxRows: 4 }}
                  style={{
                    flex: 1,
                    borderRadius: "20px",
                    fontSize: "14px",
                    resize: "none",
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      setValue("");
                    }
                  }}
                />

                <button
                  style={{
                    background: "black",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50%",
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                >
                  <FontAwesomeIcon icon={faPaperPlane} />
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};
